import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["modal", "content", "title", "description"]

  open(event) {
    const title = event.currentTarget.dataset.modalTitle
    const content = event.currentTarget.dataset.modalContent
    const description = event.currentTarget.dataset.modalDescription

    if (title) this.titleTarget.textContent = title
    if (content) this.contentTarget.innerHTML = content
    if (description) this.descriptionTarget.textContent = description

    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  closeModal() {
    this.close()
  }
}
